// src/utils/dentallyPatientLinkStatus.js
//
// Presentation mapping for a practice/lead-scoped Dentally patient link
// (useDentallyPatientLink outcome). "Linked" only means identity is known —
// it is deliberately never worded as "synced" / "up to date".
import { format, isValid } from 'date-fns';

export const PATIENT_LINK_PRESENTATION = {
  idle: { key: 'checking', label: 'Checking Dentally', tone: 'neutral', icon: 'mdi:link-variant' },
  loading: { key: 'checking', label: 'Checking Dentally', tone: 'neutral', icon: 'mdi:link-variant' },
  unique: { key: 'linked', label: 'Dentally patient linked', tone: 'success', icon: 'mdi:link-variant' },
  none: { key: 'unlinked', label: 'Not linked to Dentally', tone: 'neutral', icon: 'mdi:link-variant-off' },
  ambiguous: { key: 'attention', label: 'Dentally needs attention', tone: 'warning', icon: 'mdi:alert-circle-outline' },
  malformed: { key: 'attention', label: 'Dentally needs attention', tone: 'warning', icon: 'mdi:alert-circle-outline' },
  error: { key: 'error', label: 'Could not check Dentally', tone: 'warning', icon: 'mdi:cloud-off-outline' },
};

export const TONE_COLOURS = {
  neutral: { bg: 'rgba(145, 158, 171, 0.08)', fg: '#637381' },
  success: { bg: 'rgba(0, 167, 111, 0.08)', fg: '#00A76F' },
  warning: { bg: 'rgba(255, 171, 0, 0.12)', fg: '#B76E00' },
};

export const getPatientLinkPresentation = (outcome) =>
  PATIENT_LINK_PRESENTATION[outcome] || PATIENT_LINK_PRESENTATION.error;

/** Human label for the link's `source` value (e.g. EXPORTED → "Exported"). */
export const formatPatientLinkSource = (source) => {
  if (typeof source !== 'string' || !source.trim()) return null;
  const words = source.trim().toLowerCase().replace(/[_-]+/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** "Linked on" timestamp — link creation time, not a sync time. */
export const formatPatientLinkedOn = (createdAt) => {
  if (!createdAt) return null;
  const date = new Date(createdAt);
  return isValid(date) ? format(date, 'dd/MM/yyyy HH:mm') : null;
};
